import React from "react";
import i18next from "i18next";

export const I18nContext = React.createContext<{
	ssr: boolean,
	lang?: string
}>({
	ssr: false
});
